module.exports = __webpack_public_path__ + "img/stick-it-robert.73198c4b.jpg";